<template>
	<div id="searchBar">
		<div class="textfieldContainer">
			<input type="text" name="search" class="textField"
				   v-model="searchQuery" v-on:keyup.enter="onSearch"
				   :placeholder="placeholder">
		</div>
		<IconBase v-if="!isSearching" class="icon" iconName="suchen" width="40"
				  height="40" viewBox="0 0 49 49" @onIconClicked="onSearch">
			<IconSearch/>
		</IconBase>
		<IconBase v-else class="icon" iconName="Suche löschen" width="40"
				  height="40" @onIconClicked="onDeleteSearch">
			<IconDelete/>
		</IconBase>
	</div>
</template>

<script>
	import IconBase from '@/components/icons/IconBase.vue';
	import IconSearch from '@/components/icons/IconSearch.vue';
	import IconDelete from '@/components/icons/IconDelete.vue';
	import {EventBus} from '@/services/EventBus.js';

	export default {
		name: "SearchBar",
		props: ['placeholder'],
		components: {
			IconBase,
			IconSearch,
			IconDelete
		},
		data() {
			return {
				searchQuery: null,
				isSearching: false
			}
		},
		methods: {
			onSearch() {
				if (this.searchQuery) {
					EventBus.$emit('onSearch', this.searchQuery.toLowerCase());
					this.isSearching = true;
				}
			},
			onDeleteSearch() {
				EventBus.$emit('onDeleteSearch');
				this.isSearching = false;
				this.searchQuery = '';
			}
		},
		mounted() {
			this.isSearching = false;
			this.searchQuery = '';
		}
	}
</script>

<style scoped>

	#searchBar {
		width: 100%;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		margin: 0;
		position: absolute;
		bottom: 0;
		left: 0;
	}

	.textFieldContainer {
		flex-grow: 1;
	}

	.textfieldContainer {
		width: 100%;
	}

	.textField {
		height: 40px;
		font-family: "BrownLLWeb-Regular";
		font-size: 20px;
		background-color: black;
		color: white;
		padding-left: 15px;
		margin: 0;
		border: 0;
		width: 100%;
		box-sizing: border-box;
	}

	.icon {
		flex-grow: 0;
		flex-shrink: 0;
	}

</style>